// source: witbooking/backoffice/promotion/v1/promotion_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.LegacyPromotion', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.Promotion', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.displayName = 'proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.displayName = 'proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.displayName = 'proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.displayName = 'proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.displayName = 'proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.displayName = 'proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.displayName = 'proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.displayName = 'proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.Promotion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.Promotion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.Promotion.displayName = 'proto.witbooking.backoffice.promotion.v1.Promotion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.promotion.v1.LegacyPromotion.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.LegacyPromotion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.LegacyPromotion.displayName = 'proto.witbooking.backoffice.promotion.v1.LegacyPromotion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.promotion.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.promotion.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.promotion.v1.Translation.displayName = 'proto.witbooking.backoffice.promotion.v1.Translation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest;
  return proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    promotionsList: jspb.Message.toObjectList(msg.getPromotionsList(),
    proto.witbooking.backoffice.promotion.v1.Promotion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse;
  return proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.promotion.v1.Promotion;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.Promotion.deserializeBinaryFromReader);
      msg.addPromotions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromotionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.promotion.v1.Promotion.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Promotion promotions = 1;
 * @return {!Array<!proto.witbooking.backoffice.promotion.v1.Promotion>}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.getPromotionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.promotion.v1.Promotion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.promotion.v1.Promotion, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.promotion.v1.Promotion>} value
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse} returns this
*/
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.setPromotionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.promotion.v1.Promotion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.promotion.v1.Promotion}
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.addPromotions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.promotion.v1.Promotion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse} returns this
 */
proto.witbooking.backoffice.promotion.v1.GetPromotionsResponse.prototype.clearPromotionsList = function() {
  return this.setPromotionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    promotion: (f = msg.getPromotion()) && proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest;
  return proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.promotion.v1.LegacyPromotion;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader);
      msg.setPromotion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromotion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyPromotion promotion = 1;
 * @return {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.getPromotion = function() {
  return /** @type{?proto.witbooking.backoffice.promotion.v1.LegacyPromotion} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.promotion.v1.LegacyPromotion, 1));
};


/**
 * @param {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest} returns this
*/
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.setPromotion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest} returns this
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.clearPromotion = function() {
  return this.setPromotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionRequest.prototype.hasPromotion = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    promotion: (f = msg.getPromotion()) && proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse;
  return proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.promotion.v1.LegacyPromotion;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader);
      msg.setPromotion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromotion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyPromotion promotion = 1;
 * @return {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.getPromotion = function() {
  return /** @type{?proto.witbooking.backoffice.promotion.v1.LegacyPromotion} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.promotion.v1.LegacyPromotion, 1));
};


/**
 * @param {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse} returns this
*/
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.setPromotion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse} returns this
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.clearPromotion = function() {
  return this.setPromotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.CreateLegacyPromotionResponse.prototype.hasPromotion = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    promotion: (f = msg.getPromotion()) && proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest;
  return proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.promotion.v1.LegacyPromotion;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader);
      msg.setPromotion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromotion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyPromotion promotion = 1;
 * @return {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.getPromotion = function() {
  return /** @type{?proto.witbooking.backoffice.promotion.v1.LegacyPromotion} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.promotion.v1.LegacyPromotion, 1));
};


/**
 * @param {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest} returns this
*/
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.setPromotion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest} returns this
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.clearPromotion = function() {
  return this.setPromotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionRequest.prototype.hasPromotion = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    promotion: (f = msg.getPromotion()) && proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse;
  return proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.promotion.v1.LegacyPromotion;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader);
      msg.setPromotion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromotion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyPromotion promotion = 1;
 * @return {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.getPromotion = function() {
  return /** @type{?proto.witbooking.backoffice.promotion.v1.LegacyPromotion} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.promotion.v1.LegacyPromotion, 1));
};


/**
 * @param {?proto.witbooking.backoffice.promotion.v1.LegacyPromotion|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse} returns this
*/
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.setPromotion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse} returns this
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.clearPromotion = function() {
  return this.setPromotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.UpdateLegacyPromotionResponse.prototype.hasPromotion = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest;
  return proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest} returns this
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionRequest.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse;
  return proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.DeleteLegacyPromotionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.Promotion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.Promotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.Promotion.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legacyId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.Promotion}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.Promotion;
  return proto.witbooking.backoffice.promotion.v1.Promotion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.Promotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.Promotion}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegacyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.Promotion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.Promotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.Promotion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.Promotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 legacy_id = 2;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.Promotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.Promotion.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.repeatedFields_ = [37,38];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isPercentage: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    reduction: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    fechaini: (f = msg.getFechaini()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    fechafin: (f = msg.getFechafin()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    visibleInEngine: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    activa: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    orden: jspb.Message.getFieldWithDefault(msg, 16, 0),
    codigopromocional: jspb.Message.getFieldWithDefault(msg, 18, ""),
    grupo: jspb.Message.getFieldWithDefault(msg, 19, 0),
    fechainicontratacion: (f = msg.getFechainicontratacion()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    fechafincontratacion: (f = msg.getFechafincontratacion()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    fbloqueoTip: jspb.Message.getFieldWithDefault(msg, 24, 0),
    festanciaMinima: jspb.Message.getFieldWithDefault(msg, 25, 0),
    festanciaMinimaTip: jspb.Message.getFieldWithDefault(msg, 26, 0),
    festanciaMaxima: jspb.Message.getFieldWithDefault(msg, 27, 0),
    festanciaMaximaTip: jspb.Message.getFieldWithDefault(msg, 28, 0),
    freleaseMinimo: jspb.Message.getFieldWithDefault(msg, 29, 0),
    freleaseMinimoTip: jspb.Message.getFieldWithDefault(msg, 30, 0),
    freleaseMaximo: jspb.Message.getFieldWithDefault(msg, 31, 0),
    freleaseMaximoTip: jspb.Message.getFieldWithDefault(msg, 32, 0),
    discountedNights: jspb.Message.getFieldWithDefault(msg, 33, 0),
    minStayForDiscountedNights: jspb.Message.getFieldWithDefault(msg, 34, 0),
    stackDiscountedNights: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    discountedNightCriteria: jspb.Message.getFieldWithDefault(msg, 36, ""),
    inventoriesList: (f = jspb.Message.getRepeatedField(msg, 37)) == null ? undefined : f,
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.promotion.v1.Translation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.LegacyPromotion;
  return proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPercentage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReduction(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFechaini(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFechafin(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisibleInEngine(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiva(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrden(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCodigopromocional(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGrupo(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFechainicontratacion(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFechafincontratacion(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFbloqueoTip(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFestanciaMinima(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFestanciaMinimaTip(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFestanciaMaxima(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFestanciaMaximaTip(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreleaseMinimo(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreleaseMinimoTip(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreleaseMaximo(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreleaseMaximoTip(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountedNights(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinStayForDiscountedNights(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStackDiscountedNights(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountedNightCriteria(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.addInventories(value);
      break;
    case 38:
      var value = new proto.witbooking.backoffice.promotion.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.promotion.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIsPercentage();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getReduction();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getFechaini();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFechafin();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVisibleInEngine();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getActiva();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getOrden();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getCodigopromocional();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getGrupo();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getFechainicontratacion();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFechafincontratacion();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFbloqueoTip();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getFestanciaMinima();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getFestanciaMinimaTip();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getFestanciaMaxima();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getFestanciaMaximaTip();
  if (f !== 0) {
    writer.writeInt32(
      28,
      f
    );
  }
  f = message.getFreleaseMinimo();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getFreleaseMinimoTip();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getFreleaseMaximo();
  if (f !== 0) {
    writer.writeInt32(
      31,
      f
    );
  }
  f = message.getFreleaseMaximoTip();
  if (f !== 0) {
    writer.writeInt32(
      32,
      f
    );
  }
  f = message.getDiscountedNights();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getMinStayForDiscountedNights();
  if (f !== 0) {
    writer.writeInt32(
      34,
      f
    );
  }
  f = message.getStackDiscountedNights();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getDiscountedNightCriteria();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      37,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      38,
      f,
      proto.witbooking.backoffice.promotion.v1.Translation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 id = 2;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool is_percentage = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getIsPercentage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setIsPercentage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double reduction = 4;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getReduction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setReduction = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp fechaini = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFechaini = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
*/
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFechaini = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearFechaini = function() {
  return this.setFechaini(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.hasFechaini = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp fechafin = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFechafin = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
*/
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFechafin = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearFechafin = function() {
  return this.setFechafin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.hasFechafin = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool visible_in_engine = 9;
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getVisibleInEngine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setVisibleInEngine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool activa = 15;
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getActiva = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setActiva = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional int32 orden = 16;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getOrden = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setOrden = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string codigopromocional = 18;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getCodigopromocional = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setCodigopromocional = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 grupo = 19;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getGrupo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setGrupo = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional google.protobuf.Timestamp fechainicontratacion = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFechainicontratacion = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
*/
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFechainicontratacion = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearFechainicontratacion = function() {
  return this.setFechainicontratacion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.hasFechainicontratacion = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp fechafincontratacion = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFechafincontratacion = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
*/
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFechafincontratacion = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearFechafincontratacion = function() {
  return this.setFechafincontratacion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.hasFechafincontratacion = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional int32 fbloqueo_tip = 24;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFbloqueoTip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFbloqueoTip = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 festancia_minima = 25;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFestanciaMinima = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFestanciaMinima = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int32 festancia_minima_tip = 26;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFestanciaMinimaTip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFestanciaMinimaTip = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int32 festancia_maxima = 27;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFestanciaMaxima = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFestanciaMaxima = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional int32 festancia_maxima_tip = 28;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFestanciaMaximaTip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFestanciaMaximaTip = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int32 frelease_minimo = 29;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFreleaseMinimo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFreleaseMinimo = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int32 frelease_minimo_tip = 30;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFreleaseMinimoTip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFreleaseMinimoTip = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int32 frelease_maximo = 31;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFreleaseMaximo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFreleaseMaximo = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional int32 frelease_maximo_tip = 32;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getFreleaseMaximoTip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setFreleaseMaximoTip = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional int32 discounted_nights = 33;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getDiscountedNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setDiscountedNights = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int32 min_stay_for_discounted_nights = 34;
 * @return {number}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getMinStayForDiscountedNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setMinStayForDiscountedNights = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional bool stack_discounted_nights = 35;
 * @return {boolean}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getStackDiscountedNights = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setStackDiscountedNights = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional string discounted_night_criteria = 36;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getDiscountedNightCriteria = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setDiscountedNightCriteria = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * repeated string inventories = 37;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getInventoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 37));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setInventoriesList = function(value) {
  return jspb.Message.setField(this, 37, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.addInventories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 37, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearInventoriesList = function() {
  return this.setInventoriesList([]);
};


/**
 * repeated Translation translations = 38;
 * @return {!Array<!proto.witbooking.backoffice.promotion.v1.Translation>}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.promotion.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.promotion.v1.Translation, 38));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.promotion.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
*/
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 38, value);
};


/**
 * @param {!proto.witbooking.backoffice.promotion.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation}
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 38, opt_value, proto.witbooking.backoffice.promotion.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.promotion.v1.LegacyPromotion} returns this
 */
proto.witbooking.backoffice.promotion.v1.LegacyPromotion.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.promotion.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.promotion.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation}
 */
proto.witbooking.backoffice.promotion.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.promotion.v1.Translation;
  return proto.witbooking.backoffice.promotion.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.promotion.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation}
 */
proto.witbooking.backoffice.promotion.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.promotion.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.promotion.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.promotion.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation} returns this
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation} returns this
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.promotion.v1.Translation} returns this
 */
proto.witbooking.backoffice.promotion.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.promotion.v1);
